// authSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  organisation: {},
  accountType: [],
  allComponentsIds: [],
  allReportCategory: [],
  allDocTemplate: [],
  allOrgProfileTypes: [],
  allOrganizations: [],
  allViews: [],
  allReportTypes: []
};

const authSlice = createSlice({
  name: "globalAuth",
  initialState,
  reducers: {
    setOrganisation: (state, action) => {
      state.organisation = action.payload;
    },
    setAccountType: (state, action) => {
      state.accountType = action.payload;
    },
    setAllComponentsIds: (state, action) => {
      state.allComponentsIds = action.payload;
    },
    setAllReportCategory: (state, action) => {
      state.allReportCategory = action.payload;
    },
    setAllDocTemplate: (state, action) => {
      state.allDocTemplate = action.payload;
    },
    setAllOrgProfileTypes: (state, action) => {
      state.allOrgProfileTypes = action.payload;
    },
    setAllOrganizations: (state, action) => {
      state.allOrganizations = action.payload;
    },
    setAllViews: (state, action) => {
      state.allViews = action.payload.map(it=>({label:it,value:it}));
    },
    setAllReportTypes: (state, action)=>{
      state.allReportTypes = action.payload.map(it=>({label:it.name,value:it.id}));
    }
  },
});

export const {
  setOrganisation,
  setAccountType,
  setAllComponentsIds,
  setAllReportCategory,
  setAllDocTemplate,
  setAllOrgProfileTypes,
  setAllOrganizations,
  setAllViews,
  setAllReportTypes
} = authSlice.actions;
export default authSlice.reducer;
